// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__5GpxT","rightAdornment":"Header_rightAdornment__3up1-"};